import { AiFillCloseCircle } from "react-icons/ai";
import { useStores } from "../../store";
import { ImWhatsapp } from "react-icons/im";
import { FaLinkedin, FaYoutube } from "react-icons/fa";
import { IoLogoInstagram } from "react-icons/io5";

export default function Connect() {
    const {PopupStore} = useStores();
    return(
        <div onClick={() => PopupStore.setConnectPopup(false)} className="fixed w-screen h-screen gil-reg z-[51] inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40">
          <div onClick={(e) => e.stopPropagation()} className="fixed  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-xl items-center md:w-[60%] lg:w-[60%] w-[90%] h-[45%] md:h-[45%] lg:h-[45%] m-auto shadow-lg overflow-y-auto no-scrollbar">
            <div className="flex flex-col items-center  h-full py-5 w-[100%] md:w-[100%] lg:[100%] border ">
              <AiFillCloseCircle
                className="text-primary absolute text-2xl lg:text-4xl cursor-pointer  top-2 right-2"
                onClick={() => PopupStore.setConnectPopup(false)}
              />
              <h1 className="md:text-2xl text-lg lg:md:text-4xl md:mt-10 lg:mt-10 mt-2">Connect with us for more Updates</h1>
              <p className="px-10 text-center text-gray-500 mt-5 text-sm">We invite you to connect with us to stay informed about upcoming job fairs and events. By engaging with our community, you’ll have the opportunity to network, explore new career paths, and gain insights into various industries. Don’t miss out on the chance to enhance your professional journey!</p>
              <div className="flex md:text-5xl lg:text-5xl text-4xl gap-10 mt-7 md:mt-[10%] lg:mt-16">
              <a href="https://chat.whatsapp.com/HiEWE92Z3af51Sd5Iqffd4"> <ImWhatsapp  className="text-green-500" /> </a>
              <a href="https://www.linkedin.com/company/reaidy/"> <FaLinkedin className="text-blue-500" /> </a>
              <a href="https://www.instagram.com/reaidy.io/"> <IoLogoInstagram className="text-pink-500" /> </a>
              <a href="https://www.youtube.com/@reaidy"> <FaYoutube className="text-red-500" /> </a>
              </div>
            </div>
            </div>
            </div>
    )
}